import React from 'react';

export default ({isSuper, userData, children, isSeniorAgent}) => {
    // allows only senior agent and admin
    return isSuper || isSeniorAgent ?
        React.cloneElement(children, {isSuper, userData, isSeniorAgent})
        : (
        <div className='SuperAgent'>
            <h1>Not Authorized</h1>
            <p>Additional account permissions needed to view this page.</p>
        </div>
        )
}